import { render, staticRenderFns } from "./direct_message_history_dialog.vue?vue&type=template&id=4c3ebace&scoped=true"
import script from "./direct_message_history_dialog.vue?vue&type=script&lang=ts"
export * from "./direct_message_history_dialog.vue?vue&type=script&lang=ts"
import style0 from "./direct_message_history_dialog.vue?vue&type=style&index=0&id=4c3ebace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ebace",
  null
  
)

export default component.exports